<div class="layered-waves" [ngStyle]="{ 'background-image': 'url(' + '/assets/svg/' + svgFile + ')' }">

</div>